import { render } from "./CatalogLayout.vue?vue&type=template&id=00b4ca14"
import script from "./CatalogLayout.vue?vue&type=script&lang=js"
export * from "./CatalogLayout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__